import { useAppSelector } from '../../../hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Vehicle } from '../../../data/models/vehicle.model';
import * as referenceSlice from '../../../data/reference.slice';
import { useFormatDate } from '../../../hooks/useFormatDate';
import { useVehicleType } from '../../../hooks/useVehicleType';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface BasicInfoProps {
  vehicle: Vehicle | null;
  titleStyle: string;
}

export default function BasicInfo(props: BasicInfoProps) {
  const { t } = useTranslation('common');

  const { vehicle, titleStyle } = props;
  const colors = useAppSelector(referenceSlice.selectVehicleColors);

  const getColor = (colorId: number | undefined) => {
    return colors.find((c) => c.vehicleColorID === colorId)?.vehicleColorName;
  };

  return (
    <>
      <Typography className={titleStyle}>{t('vehicle.attributes')}</Typography>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('vehicle.make')} value={vehicle?.vehicleMake} />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.model')}
            value={vehicle?.vehicleModel}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.year')}
            value={vehicle?.vehicleYear ? '' + vehicle?.vehicleYear : ''}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.type')}
            value={useVehicleType(vehicle?.vehicleTypeID)}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.color')}
            value={vehicle?.vehicleColor}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.license')}
            value={vehicle?.licensePlate}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.state')}
            value={vehicle?.licensePlateIssuedInStateCode}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.vin')}
            value={vehicle?.vehicleVIN}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('vehicle.regExpires')}
            value={useFormatDate(vehicle?.registrationExpiresOn)}
          />
        </Grid>
      </Grid>
    </>
  );
}
